import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";

import { LunaCodeNode } from "../../common/models/rules.model";
import { FlowTemplateService } from "./flow-template.service";

@Injectable()
export class RuleBuilderService {

    constructor(public http: HttpClient) {
    }

    compileExpression(expToEval: string): Observable<LunaCodeNode> {
        const json = { expression: expToEval };
        return this.http.post<LunaCodeNode>(`${FlowTemplateService.baseUrl}/ruleCompiler`, json);
    }

}